import Link from 'next/link'

export default function Custom404() {
    return(
       <>
         <div className="error d-flex flex-column vh-100 px-3">
            <div className="bg-light-blue text-white text-center mx-auto p-3 error-text">
                <p className="h1 mb-4">Sorry...</p>
                <p className="mb-0">This Page is not exist</p>
                <p>If you think this is in error, please <Link href="https://www.yourfreedomprojecthub.com/support/submit-ticket"><a className="text-white"><u>send a message</u></a></Link> to our Support team.</p>
            </div>
            <p className="align-items-end mt-auto text-center font-weight-normal h6">©Your Freedom Project. All Rights Reserved.</p>
        </div> 
        <style jsx>
            {`
                .h6{
                    font-size:.92rem;
                }
            `}
        </style>
       </>
    )
  }